import React from "react";
import { NeurapulseTestCompletionStatusType } from "src/common/Enums";
import IconNpTestCompleted from "../../components/icons/neurapulse/test-completed.svg?react";
import IconNpTestHighRisk from "../../components/icons/neurapulse/test-high-risk.svg?react";
import IconNpTestConfirming from "../../components/icons/neurapulse/test-confirming.svg?react";
import IconNpTestNotStarted from "../../components/icons/neurapulse/test-not-started.svg?react";
import IconNpTestCncTimedout from "../../components/icons/neurapulse/test-cnc-timedout.svg?react";
import IconNpTestInProgress from "../../components/icons/neurapulse/test-in-progress.svg?react";

interface IProps {
	status: NeurapulseTestCompletionStatusType;
	size?: number;
	style?: React.CSSProperties;
}

export const getNeurapulseTitle = (
	status: NeurapulseTestCompletionStatusType
) => {
	switch (status) {
		case NeurapulseTestCompletionStatusType.Completed:
			return "Completed";
		case NeurapulseTestCompletionStatusType.HighRisk:
			return "High Risk";
		case NeurapulseTestCompletionStatusType.Confirming:
			return "Confirming";
		case NeurapulseTestCompletionStatusType.NotStarted:
			return "Not Started";
		case NeurapulseTestCompletionStatusType.UnknownError:
		case NeurapulseTestCompletionStatusType.UnknownStatus:
		case NeurapulseTestCompletionStatusType.CouldNotCompleteConnectionIssues:
		case NeurapulseTestCompletionStatusType.CouldNotCompleteNpServerIssues:
		case NeurapulseTestCompletionStatusType.CouldNotCompleteTimedOut:
		case NeurapulseTestCompletionStatusType.CouldNotCompleteUnsupportedDevice:
			return "Incomplete";
		case NeurapulseTestCompletionStatusType.Active:
			return "Active";
		default:
			return "In Progress";
	}
};

const NeurapulseIcon: React.FC<IProps> = ({ status, size = 16, style }) => {
	const getIconForStatus = () => {
		switch (status) {
			case NeurapulseTestCompletionStatusType.Completed:
				return <IconNpTestCompleted style={{ width: size, height: size }} />;
			case NeurapulseTestCompletionStatusType.HighRisk:
				return <IconNpTestHighRisk style={{ width: size, height: size }} />;
			case NeurapulseTestCompletionStatusType.Confirming:
				return <IconNpTestConfirming style={{ width: size, height: size }} />;
			case NeurapulseTestCompletionStatusType.NotStarted:
				return <IconNpTestNotStarted style={{ width: size, height: size }} />;
			case NeurapulseTestCompletionStatusType.UnknownError:
			case NeurapulseTestCompletionStatusType.UnknownStatus:
			case NeurapulseTestCompletionStatusType.CouldNotCompleteConnectionIssues:
			case NeurapulseTestCompletionStatusType.CouldNotCompleteNpServerIssues:
			case NeurapulseTestCompletionStatusType.CouldNotCompleteTimedOut:
			case NeurapulseTestCompletionStatusType.CouldNotCompleteUnsupportedDevice:
				return <IconNpTestCncTimedout style={{ width: size, height: size }} />;
			default:
				return <IconNpTestInProgress style={{ width: size, height: size }} />;
		}
	};

	return (
		<span title={getNeurapulseTitle(status)} style={{ ...style }}>
			{getIconForStatus()}
		</span>
	);
};

export default NeurapulseIcon;
